import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "@volca/ui/lib/toast";
import type { IBusiness } from "@/business/business";
import { onboardingProductPath } from "@/onboarding/routes";

const toastSeenKey = (businessId: IBusiness["id"]) =>
  `volca:setup-complete-toast:${businessId}`;

const announceSetupComplete = (businessId: IBusiness["id"]) => {
  try {
    if (localStorage.getItem(toastSeenKey(businessId))) return;
    localStorage.setItem(toastSeenKey(businessId), "1");
  } catch {
    return;
  }
  toast.success("Your setup is complete");
};

export const ProductReadyRedirect = ({ business }: { business: IBusiness }) => {
  useEffect(() => {
    announceSetupComplete(business.id);
  }, [business.id]);
  return <Navigate to={onboardingProductPath(business)} replace />;
};
